import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import Layout from '../components/Layout'

function truncateByWords(text, wordLimit) {
  const words = text.trim().replace(/\s+/g, ' ').split(' ')
  if (words.length <= wordLimit) return text
  return words.slice(0, wordLimit).join(' ') + '...'
}

export default function Blog() {
  const [posts, setPosts] = useState([])
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    fetch('/blogData.json')
      .then((res) => {
        if (!res.ok) throw new Error(res.statusText)
        return res.json()
      })
      .then(setPosts)
      .catch(() => setFailed(true))
  }, [])

  return (
    <Layout title='Blog'>
      <div className='max-w-3xl'>
        {failed && (
          <p className='text-sm text-gray-600'>Posts could not be loaded. Please refresh the page.</p>
        )}
        <ul className='space-y-8'>
          {posts.map((post, index) => (
            <React.Fragment key={post.slug}>
              <li>
                <NavLink to={`/blog/${post.slug}`}>
                  <h2 className='text-lg lg:text-xl font-bold hover:underline'>
                    {post.title}
                  </h2>
                </NavLink>
                <div className='text-sm text-gray-500 py-1'>{post.date}</div>
                <div className='text-sm text-gray-600'>
                  {truncateByWords(post.content.replace(/\n/g, ' '), 30)}
                </div>
              </li>
              {index < posts.length - 1 && <hr />}
            </React.Fragment>
          ))}
        </ul>
      </div>
    </Layout>
  )
}
